import {isEmpty} from 'lodash';
import commonGetters from 'top20common/distribution/store/getters';

export default {
  ...commonGetters,
  canInterractWithJob(state, getters) {
    let loading = isEmpty(getters.jobDetailsState) || isEmpty(getters.profileDetailsState);

    if (!loading && getters.isLoggedIn) {
      let isSameSource = getters.jobDetailsState.external_source === getters.profileDetailsState.source;
      let isCandidateWithJobSource = getters.isCandidateUser && isSameSource;

      return getters.isEmployerUser || isCandidateWithJobSource;
    }

    return true;
  },
  cvPreviewPdfLoadingState(state) {
    return state.cvPreviewPdfLoadingState;
  }
};
